import React, { useState } from 'react';
import { MagnifyingGlass, MapPin } from 'phosphor-react';
import { SLabel } from '@/components/ui/atoms/SLabel';
import { SInputField } from '@/components/ui/molecules/SInputField';
import { SNavigationButton } from '@/components/ui/atoms/SNavigationButton';
import { SFooterDrawer } from '@/components/ui/organisms/SFooterDrawer';
import './SelectStateDrawer.css';

export interface SelectStateDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  currentState?: string;
  onStateSelect?: (state: string) => void;
}

/** Shared with v2's Personal screen — one list, not two. */
export const usStates = [
  'Alabama',
  'Alaska',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'Delaware',
  'Florida',
  'Georgia',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York',
  'North Carolina',
  'North Dakota',
  'Ohio',
  'Oklahoma',
  'Oregon',
  'Pennsylvania',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'Utah',
  'Vermont',
  'Virginia',
  'Washington',
  'West Virginia',
  'Wisconsin',
  'Wyoming',
];

export const SelectStateDrawer: React.FC<SelectStateDrawerProps> = ({
  isOpen,
  onClose,
  currentState = 'Utah',
  onStateSelect,
}) => {
  const [searchQuery, setSearchQuery] = useState('');

  const filteredStates = usStates.filter((state) =>
    state.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleStateSelect = (state: string) => {
    if (onStateSelect) {
      onStateSelect(state);
    }
    onClose();
  };

  return (
    <SFooterDrawer
      isOpen={isOpen}
      onClose={onClose}
      title="Select State"
      height="85%"
    >
      <div className="select-state-drawer-content">
        {/* Search Input */}
        <div className="select-state-search">
          <SInputField
            size="m"
            state="default"
            placeholder="Search"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            showIcon={true}
            icon={<MagnifyingGlass size={20} color="#696D77" />}
            iconPosition="right"
          />
        </div>

        {/* Current State */}
        <div className="select-state-current-section">
          <SNavigationButton
            leftIcon={<MapPin size={24} color="#BD9734" />}
            label={currentState}
            subLabel="Current State"
          />
        </div>

        {/* Other States Label */}
        <div className="select-state-other-label">
          <SLabel>Other States</SLabel>
        </div>

        {/* States List */}
        <div className="select-state-list">
          {filteredStates.map((state) => (
            <SNavigationButton
              key={state}
              label={state}
              onClick={() => handleStateSelect(state)}
            />
          ))}
        </div>
      </div>
    </SFooterDrawer>
  );
};

export default SelectStateDrawer;
